import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, Observable } from 'rxjs';
import { State } from 'src/app/reducers';
import { User } from 'src/app/store/auth/auth.models';
import { ResumeProps } from 'src/app/store/resume/resume.models';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-create-resume',
  templateUrl: './create-resume.component.html',
  styleUrls: ['./create-resume.component.scss'],
})
export class CreateResumeComponent implements OnInit {
  private destroyer$: Subject<any> = new Subject();
  loadingUserResumes$: Observable<boolean>;
  loadingUserError$: Observable<string>;
  currentUser: User;
  userResumes: ResumeProps;
  skillLevels: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  constructor(private store: Store<State>) {
    // Attach to the store
    this.store
      .select((state) => state.auth.authenticatedUser)
      .pipe(takeUntil(this.destroyer$))
      .subscribe((user) => {
        this.currentUser = user;
        if (user) {
          // here we have got the authenticated user and we can now fetch all the assessment that user already did in the system
          // this.store.dispatch(this.loadingGoals$({ userId: user.sub }));
        }
      });
  }

  ngOnInit(): void {}

  getUserFullName(): string {
    return this.currentUser
      ? `${this.currentUser.given_name} ${this.currentUser.family_name}`
      : '';
  }
}
